import { createApp } from 'vue';
import PrimeVue from 'primevue/config';
import ToastService from 'primevue/toastservice';
import App from './App.vue';
import './styles/tailwind.css';
import './styles/game-animations.css';
import './styles/letter-tiles.css';
import 'primeicons/primeicons.css';
import { validateConfiguration } from '@/config/constants';
import { initTelemetry, shutdownTelemetry } from '@/telemetry/init';
import { reportWebVitals } from '@/telemetry/webVitals';
import { initSpaObservers } from '@/telemetry/spaObservers';
import { ErrorLocation, reportClientError } from '@/telemetry/errors';
import '@/telemetry/openpanel';
import { router } from './router';

// Initialize OpenTelemetry before anything else
initTelemetry();

// Validate configuration at application startup
try {
  validateConfiguration();
} catch (error) {
  console.error('Configuration validation failed:', error);
  throw error;
}

const app = createApp(App);

app.config.errorHandler = err => {
  reportClientError(err, ErrorLocation.VueRenderError);
};

// Configure PrimeVue in unstyled mode for full Tailwind CSS control
app.use(PrimeVue, {
  unstyled: true,
  ripple: true, // Enable ripple effect for better UX
});
app.use(ToastService);
app.use(router);

app.mount('#app');

// Report Web Vitals after mount
reportWebVitals();
initSpaObservers();

// Flush telemetry on page unload
window.addEventListener('beforeunload', () => {
  shutdownTelemetry();
});
